<template>
  <div class="controls">
    <div class="control-grid">
      <button data-color="red" @touchstart="shootColor"></button>
      <button data-color="green" @touchstart="shootColor"></button>
      <button data-color="blue" @touchstart="shootColor"></button>
      <button data-color="white" @touchstart="shootColor"></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Controls',
  props: ['gamestate'],
  methods: {
    shootColor(e) {
      if (this.gamestate === 'playing') this.$emit('shootColor', e.target.getAttribute('data-color'));
    },
  },
};
</script>

<style scoped lang="scss">
.controls {
  box-shadow: 0 -5px 8px rgba(0, 0, 0, 0.5);
  height: 60vh;
  //overflow: hidden;
  position: relative;
  transition: transform 0.3s ease-in;
  z-index: 2;
}

.control-grid {
  align-content: space-around;
  background: #999;
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  justify-content: space-around;
  user-select: none;
}

button {
  background: transparent;
  border: 0 none;
  border-radius: 25px;
  height: 45%;
  outline: none;
  position: relative;
  top: -18px;
  transform-origin: center calc(100% + 10px);
  transition: transform 0.1s;
  will-change: transform;
  width: 45%;

  &[data-color='red'] {
    background: #f04848;
    box-shadow: 0 10px 0 darken(#f04848, 10%), 0 14px 2px #666;
  }
  &[data-color='green'] {
    background: #58f048;
    box-shadow: 0 10px 0 darken(#58f048, 10%), 0 14px 2px #666;
  }
  &[data-color='white'] {
    background: white;
    box-shadow: 0 10px 0 darken(white, 10%), 0 14px 2px #666;
  }
  &[data-color='blue'] {
    background: #18a8f0;
    box-shadow: 0 10px 0 darken(#18a8f0, 10%), 0 14px 2px #666;
  }

  .countdown + .controls & {
    pointer-events: none;
  }

  &:active {
    transform: scaleY(0.9);
  }
}
</style>
